var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8, _linearGradient9, _path9, _linearGradient0, _path0, _linearGradient1, _path1, _linearGradient10, _path10, _path11, _g, _g2, _path12, _linearGradient11, _rect, _path13, _path14, _path15, _radialGradient, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5a_vq2TUn1kG0Uv_gr1",
    x1: 23.967,
    x2: 24.308,
    y1: 23.847,
    y2: -1.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5a_vq2TUn1kG0Uv_gr1)",
    d: "M16,16.077c0-4.54,3.487-8.234,8-8.234s8.185,3.694,8.185,8.234v10.655H37V16.077 C37,8.866,31.168,3,24,3S11,8.866,11,16.077v6.781h5V16.077z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5b_vq2TUn1kG0Uv_gr2",
    x1: 16.429,
    x2: 16.788,
    y1: 24.749,
    y2: -2.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5b_vq2TUn1kG0Uv_gr2)",
    d: "M14.462,16.112c0-2.146,0.501-4.018,1.481-5.623s2.438-2.941,4.352-4.015 c1.683-0.944,1.314-2.649-0.96-1.72c-1.223,0.5-2.341,1.236-3.317,2.13s-1.811,1.945-2.467,3.074 c-1.054,1.813-1.658,3.915-1.658,6.154l0.015,5.66l2.489,0.023L14.462,16.112z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5c_vq2TUn1kG0Uv_gr3",
    x1: 16.331,
    x2: 16.688,
    y1: 24.735,
    y2: -2.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ececec"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5c_vq2TUn1kG0Uv_gr3)",
    d: "M13.637,9.944c-1.072,1.817-1.689,3.939-1.695,6.248l0.014,5.584l0.699,0.007l1.616-0.12 l0.044-4.007c0.001-0.043,0.02-1.554,0.024-1.593c0.015-2.128,0.511-3.972,1.458-5.546c0.326-0.543,0.705-1.053,1.136-1.533 c0.762-0.85,1.685-1.601,2.761-2.259c0.115-0.07,0.231-0.139,0.349-0.207c1.319-0.754,1.383-1.922,0.262-1.938 c-0.162-0.002-0.395,0.029-0.686,0.133c-0.09,0.032-0.184,0.068-0.282,0.109c-1.173,0.494-2.249,1.199-3.194,2.048 c-0.022,0.02-0.043,0.039-0.065,0.059C15.115,7.806,14.289,8.835,13.637,9.944z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5d_vq2TUn1kG0Uv_gr4",
    x1: 16.234,
    x2: 16.59,
    y1: 24.723,
    y2: -2.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebeb"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5d_vq2TUn1kG0Uv_gr4)",
    d: "M13.724,9.929c-1.091,1.822-1.721,3.963-1.732,6.343l0.013,5.508l0.686,0.008l1.455-0.257 l0.041-3.947c0.002-0.087,0.022-1.491,0.028-1.571c0.031-2.11,0.521-3.925,1.436-5.47c0.318-0.539,0.687-1.045,1.105-1.519 c0.747-0.852,1.649-1.6,2.694-2.255c0.112-0.071,0.225-0.14,0.341-0.208c1.253-0.737,1.375-1.751,0.45-1.891 c-0.112-0.017-0.326-0.005-0.623,0.107c-0.089,0.034-0.181,0.07-0.276,0.111c-1.151,0.5-2.207,1.194-3.137,2.026 c-0.021,0.019-0.043,0.038-0.064,0.058C15.189,7.834,14.373,8.84,13.724,9.929z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5e_vq2TUn1kG0Uv_gr5",
    x1: 16.146,
    x2: 16.5,
    y1: 24.713,
    y2: -2.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5e_vq2TUn1kG0Uv_gr5)",
    d: "M13.812,9.914c-1.109,1.826-1.752,3.987-1.77,6.437l0.011,5.432l0.673,0.009l1.294-0.393 l0.038-3.887c0.003-0.13,0.023-1.429,0.033-1.548c0.046-2.093,0.531-3.878,1.413-5.393c0.31-0.536,0.669-1.037,1.074-1.506 c0.732-0.854,1.613-1.599,2.627-2.251c0.109-0.071,0.22-0.141,0.333-0.209c1.188-0.717,1.388-1.778,0.637-1.845 c-0.055-0.053-0.257-0.04-0.561,0.081c-0.087,0.035-0.178,0.072-0.271,0.113c-1.129,0.506-2.165,1.19-3.08,2.004 c-0.021,0.019-0.042,0.038-0.063,0.057C15.263,7.862,14.456,8.844,13.812,9.914z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5f_vq2TUn1kG0Uv_gr6",
    x1: 16.062,
    x2: 16.415,
    y1: 24.705,
    y2: -2.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5f_vq2TUn1kG0Uv_gr6)",
    d: "M13.899,9.899c-1.127,1.83-1.784,4.011-1.807,6.532l0.01,5.356l0.66,0.01l1.133-0.53 l0.035-3.827c0.004-0.173,0.024-1.367,0.038-1.525c0.062-2.075,0.541-3.831,1.391-5.316c0.302-0.532,0.652-1.028,1.043-1.492 c0.719-0.855,1.577-1.598,2.559-2.247c0.107-0.071,0.215-0.142,0.325-0.21c1.124-0.697,1.39-1.683,0.824-1.798 c-0.002-0.076-0.188-0.075-0.499,0.056c-0.086,0.036-0.175,0.074-0.265,0.115c-1.106,0.511-2.123,1.185-3.023,1.983 c-0.021,0.018-0.042,0.037-0.062,0.056C15.337,7.89,14.54,8.849,13.899,9.899z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5g_vq2TUn1kG0Uv_gr7",
    x1: 15.988,
    x2: 16.339,
    y1: 24.697,
    y2: -1.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5g_vq2TUn1kG0Uv_gr7)",
    d: "M13.987,9.884c-1.145,1.835-1.815,4.036-1.844,6.626l0.008,5.28l0.647,0.011l0.972-0.666 l0.031-3.766c0.005-0.216,0.026-1.304,0.043-1.502c0.077-2.057,0.551-3.784,1.368-5.24c0.295-0.529,0.634-1.02,1.012-1.479 c0.704-0.857,1.541-1.597,2.492-2.244c0.104-0.072,0.21-0.143,0.317-0.211c1.06-0.676,1.392-1.587,1.011-1.751 c0.051-0.098-0.119-0.109-0.436,0.03c-0.084,0.037-0.171,0.075-0.26,0.117c-1.084,0.517-2.082,1.181-2.966,1.961 c-0.021,0.018-0.041,0.036-0.062,0.055C15.412,7.917,14.623,8.854,13.987,9.884z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5h_vq2TUn1kG0Uv_gr8",
    x1: 15.929,
    x2: 16.279,
    y1: 24.69,
    y2: -1.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5h_vq2TUn1kG0Uv_gr8)",
    d: "M14.074,9.869c-1.163,1.839-1.847,4.06-1.881,6.721l0.007,5.204l0.634,0.011l0.811-0.803 l0.028-3.706c0.006-0.26,0.027-1.242,0.048-1.48c0.093-2.039,0.56-3.738,1.346-5.163c0.287-0.525,0.616-1.012,0.981-1.466 c0.69-0.859,1.505-1.596,2.425-2.24c0.102-0.072,0.204-0.144,0.309-0.212c0.997-0.655,1.395-1.492,1.199-1.704 c0.104-0.12-0.05-0.144-0.374,0.005c-0.083,0.038-0.168,0.077-0.254,0.119c-1.062,0.523-2.04,1.176-2.909,1.939 c-0.02,0.018-0.041,0.036-0.061,0.054C15.486,7.945,14.707,8.859,14.074,9.869z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5i_vq2TUn1kG0Uv_gr9",
    x1: 15.929,
    x2: 16.278,
    y1: 24.684,
    y2: -1.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e3e3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5i_vq2TUn1kG0Uv_gr9)",
    d: "M14.161,9.854c-1.181,1.843-1.878,4.084-1.918,6.815l0.006,5.128l0.621,0.012l0.65-0.94 l0.025-3.646c0.006-0.303,0.029-1.18,0.053-1.457c0.108-2.021,0.57-3.691,1.323-5.087c0.279-0.522,0.598-1.003,0.95-1.452 c0.675-0.861,1.469-1.595,2.357-2.236c0.099-0.072,0.199-0.144,0.301-0.213c0.934-0.633,1.397-1.397,1.386-1.657 c0.157-0.142,0.018-0.18-0.311-0.021C19.523,5.14,19.44,5.18,19.356,5.222c-1.039,0.529-1.998,1.172-2.851,1.917 c-0.02,0.017-0.04,0.035-0.06,0.053C15.56,7.973,14.79,8.864,14.161,9.854z"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5j_vq2TUn1kG0Uv_gr10",
    x1: 15.943,
    x2: 16.29,
    y1: 24.677,
    y2: -1.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e2e2"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5j_vq2TUn1kG0Uv_gr10)",
    d: "M14.249,9.839c-1.199,1.848-1.91,4.108-1.955,6.91l0.004,5.052l0.608,0.013l0.489-1.076 l0.022-3.586c0.007-0.346,0.03-1.118,0.058-1.434c0.124-2.003,0.58-3.644,1.301-5.01c0.271-0.518,0.58-0.995,0.919-1.439 c0.659-0.863,1.433-1.594,2.29-2.232c0.097-0.073,0.194-0.145,0.294-0.214c0.871-0.61,1.4-1.301,1.573-1.611 c0.21-0.164,0.087-0.215-0.249-0.046c-0.08,0.04-0.161,0.081-0.243,0.124c-1.017,0.534-1.956,1.167-2.794,1.895 c-0.02,0.017-0.039,0.034-0.059,0.051C15.635,8.001,14.874,8.869,14.249,9.839z"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5k_vq2TUn1kG0Uv_gr11",
    x1: 15.954,
    x2: 16.3,
    y1: 24.673,
    y2: -1.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0e0"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5k_vq2TUn1kG0Uv_gr11)",
    d: "M14.336,9.824c-1.217,1.852-1.941,4.132-1.992,7.004l0.003,4.976l0.595,0.014l0.328-1.213 l0.019-3.526c0.008-0.389,0.032-1.055,0.063-1.411c0.139-1.985,0.59-3.597,1.279-4.934c0.264-0.515,0.561-0.988,0.888-1.425 c0.643-0.867,1.396-1.593,2.223-2.228c0.094-0.073,0.189-0.145,0.286-0.215c0.808-0.587,1.373-1.237,1.76-1.564 c0.246-0.208,0.156-0.251-0.186-0.072c-0.079,0.041-0.158,0.083-0.238,0.126c-0.995,0.54-1.914,1.163-2.737,1.873 c-0.019,0.017-0.039,0.034-0.058,0.05C15.709,8.029,14.957,8.874,14.336,9.824z"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5l_vq2TUn1kG0Uv_gr12",
    x1: 15.974,
    x2: 16.319,
    y1: 24.666,
    y2: -1.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdfdf"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5l_vq2TUn1kG0Uv_gr12)",
    d: "M14.424,9.809c-1.235,1.856-1.973,4.157-2.03,7.099l0.001,4.9l0.582,0.015l0.167-1.349 l0.016-3.465c0.009-0.433,0.033-0.993,0.068-1.389c0.155-1.967,0.6-3.55,1.256-4.857c0.256-0.511,0.543-0.98,0.857-1.412 c0.628-0.869,1.36-1.591,2.156-2.225c0.092-0.073,0.184-0.146,0.278-0.216c0.746-0.564,1.393-1.127,1.948-1.517 c0.309-0.218,0.224-0.287-0.124-0.097c-0.077,0.042-0.155,0.084-0.232,0.128c-0.972,0.546-1.873,1.158-2.68,1.852 c-0.019,0.016-0.038,0.033-0.057,0.049C15.783,8.056,15.041,8.879,14.424,9.809z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    d: "M13.031,16.936c0.074-3.455,0.906-5.803,2.132-7.545c0.613-0.871,1.324-1.59,2.088-2.221 c0.764-0.631,1.581-1.172,2.405-1.688c0.369-0.231,0.292-0.323-0.061-0.123c-1.037,0.587-1.995,1.23-2.85,1.96 c-0.855,0.729-1.607,1.545-2.234,2.475c-1.253,1.86-2.004,4.181-2.067,7.194v4.824l0.569,0.015L13.031,16.936z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5m_vq2TUn1kG0Uv_gr13",
    x1: 20.144,
    x2: 20.362,
    y1: 23.539,
    y2: 7.037,
    gradientTransform: "matrix(-1 0 0 1 54.674 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5m_vq2TUn1kG0Uv_gr13)",
    d: "M34.459,16.077c0-1.894-0.082-5.06-1.695-7.703c-2.209-3.62,0.215-2.349,2.259,1.082 c1.111,1.866,1.823,4.294,1.823,6.621v10.655h-2.387V16.077z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5n_vq2TUn1kG0Uv_gr14",
    x1: 18.489,
    x2: 18.698,
    y1: 23.094,
    y2: 7.256,
    gradientTransform: "matrix(-.8182 0 0 1 49.703 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#696969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5n_vq2TUn1kG0Uv_gr14)",
    d: "M34.643,16.161c0-2.086-0.135-5.135-1.734-7.733c-2.11-3.439,0.11-2.251,2.072,0.97 c1.187,1.949,1.866,4.387,1.863,6.761l0.006,10.583l-2.201-0.022L34.643,16.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5o_vq2TUn1kG0Uv_gr15",
    x1: 15.883,
    x2: 16.083,
    y1: 22.657,
    y2: 7.47,
    gradientTransform: "matrix(-.6364 0 0 1 44.733 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbb"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5o_vq2TUn1kG0Uv_gr15)",
    d: "M34.827,16.244c0-2.278-0.187-5.21-1.773-7.764c-2.01-3.259,0.011-2.156,1.884,0.857 c1.263,2.031,1.908,4.48,1.903,6.901l0.011,10.511l-2.014-0.045L34.827,16.244z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5p_vq2TUn1kG0Uv_gr16",
    x1: 11.191,
    x2: 11.382,
    y1: 22.231,
    y2: 7.677,
    gradientTransform: "matrix(-.4545 0 0 1 39.763 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5p_vq2TUn1kG0Uv_gr16)",
    d: "M35.011,16.328c0-2.469-0.245-5.282-1.811-7.794c-1.917-3.074-0.084-2.063,1.697,0.745 c1.341,2.113,1.951,4.573,1.942,7.041l0.017,10.439l-1.828-0.067L35.011,16.328z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5q_vq2TUn1kG0Uv_gr17",
    x1: 0.227,
    x2: 0.411,
    y1: 21.82,
    y2: 7.863,
    gradientTransform: "matrix(-.2727 0 0 1 34.792 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5q_vq2TUn1kG0Uv_gr17)",
    d: "M35.195,16.412c0-2.661-0.299-5.357-1.85-7.825c-1.818-2.893-0.176-1.973,1.51,0.632 c1.42,2.195,1.993,4.666,1.982,7.181l0.022,10.367l-1.642-0.09L35.195,16.412z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5r_vq2TUn1kG0Uv_gr18",
    x1: -54.699,
    x2: -54.52,
    y1: 21.485,
    y2: 7.913,
    gradientTransform: "matrix(-.0909 0 0 1 29.822 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5r_vq2TUn1kG0Uv_gr18)",
    d: "M35.379,16.496c0-2.853-0.353-5.432-1.889-7.855c-1.719-2.712-0.263-1.885,1.323,0.52 c1.501,2.275,2.035,4.759,2.021,7.321l0.028,10.294l-1.456-0.112L35.379,16.496z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5s_vq2TUn1kG0Uv_gr19",
    x1: 110.187,
    x2: 110.348,
    y1: 20.844,
    y2: 8.625,
    gradientTransform: "matrix(.0909 0 0 1 24.852 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5s_vq2TUn1kG0Uv_gr19)",
    d: "M35.563,16.58c0-3.045-0.406-5.507-1.927-7.885c-1.619-2.531-0.348-1.798,1.136,0.408 c1.584,2.354,2.078,4.852,2.061,7.461l0.034,10.222l-1.269-0.135L35.563,16.58z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5t_vq2TUn1kG0Uv_gr20",
    x1: 55.232,
    x2: 55.388,
    y1: 20.487,
    y2: 8.669,
    gradientTransform: "matrix(.2727 0 0 1 19.881 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#adadad"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5t_vq2TUn1kG0Uv_gr20)",
    d: "M35.747,16.664c0-3.236-0.459-5.582-1.966-7.916c-1.519-2.351-0.431-1.713,0.949,0.295 c1.67,2.431,2.12,4.945,2.101,7.601l0.039,10.15l-1.083-0.157L35.747,16.664z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5u_vq2TUn1kG0Uv_gr21",
    x1: 44.245,
    x2: 44.393,
    y1: 20.1,
    y2: 8.846,
    gradientTransform: "matrix(.4545 0 0 1 14.911 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aaa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5u_vq2TUn1kG0Uv_gr21)",
    d: "M35.931,16.748c0-3.428-0.511-5.658-2.005-7.946c-1.418-2.171-0.511-1.63,0.761,0.183 c1.759,2.506,2.162,5.038,2.14,7.741l0.045,10.078l-0.897-0.18L35.931,16.748z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5v_vq2TUn1kG0Uv_gr22",
    x1: 39.537,
    x2: 39.678,
    y1: 19.71,
    y2: 9.039,
    gradientTransform: "matrix(.6364 0 0 1 9.94 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a7a7"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5v_vq2TUn1kG0Uv_gr22)",
    d: "M36.115,16.831c0-3.62-0.562-5.734-2.043-7.977c-1.316-1.992-0.589-1.549,0.574,0.07 c1.852,2.578,2.205,5.131,2.18,7.881l0.05,10.006l-0.711-0.202L36.115,16.831z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5w_vq2TUn1kG0Uv_gr23",
    x1: 36.924,
    x2: 37.057,
    y1: 19.321,
    y2: 9.234,
    gradientTransform: "matrix(.8182 0 0 1 4.97 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4a4a4"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5w_vq2TUn1kG0Uv_gr23)",
    d: "M36.299,16.915c0-3.812-0.608-5.814-2.082-8.007c-1.211-1.815-0.665-1.468,0.387-0.042 c1.951,2.645,2.247,5.224,2.219,8.021l0.056,9.934l-0.524-0.225L36.299,16.915z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5x_vq2TUn1kG0Uv_gr24",
    x1: 35.259,
    x2: 35.384,
    y1: 18.937,
    y2: 9.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1a1a1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5x_vq2TUn1kG0Uv_gr24)",
    d: "M36.483,16.999c0-4.003-0.661-5.889-2.121-8.038c-1.111-1.635-0.74-1.39,0.2-0.155 c2.059,2.705,2.29,5.317,2.259,8.161l0.061,9.862l-0.338-0.247L36.483,16.999z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5y_vq2TUn1kG0Uv_gr25",
    x1: 50.597,
    x2: 50.89,
    y1: 22.234,
    y2: 0,
    gradientTransform: "matrix(-1 0 0 1 81.907 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5y_vq2TUn1kG0Uv_gr25)",
    d: "M33.037,17.152c0-2.014-0.408-3.924-1.268-5.564c-0.86-1.64-2.173-3.011-3.983-3.947 c-1.681-0.869-1.637-1.78,0.873-0.96c1.164,0.38,2.239,0.95,3.176,1.69s1.733,1.649,2.34,2.709 c0.975,1.702,1.534,3.674,1.534,5.776v9.456l-2.795,0.296L33.037,17.152z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5z_vq2TUn1kG0Uv_gr26",
    x1: 52.653,
    x2: 52.941,
    y1: 22.074,
    y2: 0.219,
    gradientTransform: "matrix(-.8182 0 0 1 74.46 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#747474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ececec"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5z_vq2TUn1kG0Uv_gr26)",
    d: "M28.785,6.8c1.137,0.392,2.18,0.968,3.084,1.706c0.905,0.738,1.671,1.637,2.255,2.676 c0.951,1.699,1.483,3.656,1.483,5.713l0.005,9.354l-0.868,0.067l-1.729,0.052l0.101-8.681c0-0.012,0.006-0.546,0.006-0.558 c-0.004-1.957-0.392-3.827-1.222-5.448c-0.511-0.996-1.19-1.897-2.05-2.665c-0.526-0.469-1.117-0.89-1.782-1.247 c-0.727-0.391-1.117-0.785-1.135-1.031C26.911,6.425,27.464,6.345,28.785,6.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5A_vq2TUn1kG0Uv_gr27",
    x1: 55.888,
    x2: 56.173,
    y1: 22.017,
    y2: 0.386,
    gradientTransform: "matrix(-.6364 0 0 1 67.015 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5A_vq2TUn1kG0Uv_gr27)",
    d: "M28.91,6.92c1.11,0.404,2.12,0.986,2.993,1.722s1.609,1.625,2.17,2.643 c0.926,1.695,1.432,3.639,1.432,5.649l0.01,9.253l-0.841,0.04l-1.557-0.097l0.086-8.479c0-0.025,0.005-0.519,0.004-0.543 c-0.009-1.899-0.376-3.73-1.176-5.332c-0.489-0.976-1.14-1.864-1.967-2.628c-0.505-0.465-1.072-0.889-1.714-1.249 c-0.682-0.383-1.059-0.765-1.117-1.009C27.151,6.545,27.624,6.453,28.91,6.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5B_vq2TUn1kG0Uv_gr28",
    x1: 61.722,
    x2: 62.005,
    y1: 21.992,
    y2: 0.522,
    gradientTransform: "matrix(-.4545 0 0 1 59.569 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e9e9"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5B_vq2TUn1kG0Uv_gr28)",
    d: "M29.035,7.039c1.083,0.416,2.061,1.004,2.902,1.737c0.842,0.733,1.549,1.611,2.084,2.61 c0.905,1.69,1.381,3.621,1.381,5.586l0.015,9.151l-0.815,0.012l-1.385-0.247l0.072-8.277c-0.001-0.037,0.004-0.491,0.002-0.528 c-0.013-1.841-0.36-3.633-1.129-5.216c-0.467-0.955-1.09-1.83-1.884-2.592c-0.484-0.462-1.027-0.888-1.646-1.251 c-0.637-0.373-1.004-0.745-1.099-0.987C27.386,6.665,27.784,6.561,29.035,7.039z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5C_vq2TUn1kG0Uv_gr29",
    x1: 75.354,
    x2: 75.637,
    y1: 22.008,
    y2: 0.59,
    gradientTransform: "matrix(-.2727 0 0 1 52.123 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5C_vq2TUn1kG0Uv_gr29)",
    d: "M29.161,7.158c1.056,0.428,2.001,1.022,2.811,1.753c0.81,0.731,1.487,1.599,1.999,2.577 c0.881,1.686,1.33,3.603,1.33,5.522l0.02,9.049l-0.789-0.016l-1.213-0.396l0.057-8.075c-0.001-0.049,0.003-0.463,0.001-0.513 c-0.018-1.783-0.344-3.536-1.083-5.1c-0.445-0.934-1.039-1.797-1.801-2.555c-0.463-0.459-0.983-0.887-1.579-1.253 c-0.593-0.364-0.953-0.724-1.081-0.965C27.617,6.785,27.945,6.668,29.161,7.158z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5D_vq2TUn1kG0Uv_gr30",
    x1: 143.507,
    x2: 143.797,
    y1: 22.18,
    y2: 0.231,
    gradientTransform: "matrix(-.0909 0 0 1 44.676 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5D_vq2TUn1kG0Uv_gr30)",
    d: "M29.286,7.278c1.029,0.44,1.942,1.04,2.72,1.769c0.778,0.729,1.425,1.586,1.914,2.545 c0.857,1.683,1.279,3.585,1.279,5.459l0.025,8.947l-0.763-0.043l-1.041-0.545l0.043-7.873c-0.001-0.061,0.001-0.436-0.001-0.498 c-0.022-1.725-0.328-3.438-1.037-4.984c-0.423-0.913-0.989-1.763-1.718-2.519c-0.442-0.456-0.938-0.885-1.511-1.254 c-0.548-0.353-0.903-0.702-1.063-0.943C27.845,6.908,28.105,6.776,29.286,7.278z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5E_vq2TUn1kG0Uv_gr31",
    x1: -60.943,
    x2: -60.684,
    y1: 21.595,
    y2: 1.981,
    gradientTransform: "matrix(.0909 0 0 1 37.23 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9a9a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5E_vq2TUn1kG0Uv_gr31)",
    d: "M29.411,7.397c1.002,0.452,1.882,1.058,2.629,1.785c0.747,0.727,1.363,1.574,1.828,2.512 c0.833,1.68,1.228,3.567,1.228,5.396l0.029,8.846l-0.736-0.071l-0.869-0.695l0.028-7.671c-0.001-0.074,0-0.408-0.003-0.483 c-0.027-1.667-0.312-3.341-0.991-4.868c-0.401-0.892-0.938-1.73-1.636-2.482c-0.421-0.453-0.894-0.883-1.443-1.256 c-0.504-0.343-0.854-0.678-1.045-0.921C28.071,7.033,28.265,6.884,29.411,7.397z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5F_vq2TUn1kG0Uv_gr32",
    x1: 7.189,
    x2: 7.454,
    y1: 21.741,
    y2: 1.646,
    gradientTransform: "matrix(.2727 0 0 1 29.784 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e3e3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5F_vq2TUn1kG0Uv_gr32)",
    d: "M29.536,7.516c0.975,0.463,1.823,1.075,2.538,1.801c0.715,0.725,1.301,1.562,1.743,2.479 c0.808,1.677,1.177,3.549,1.177,5.332l0.034,8.744l-0.71-0.099l-0.697-0.844l0.014-7.469c-0.002-0.086-0.001-0.381-0.004-0.468 c-0.031-1.609-0.296-3.244-0.945-4.752c-0.379-0.871-0.888-1.696-1.553-2.445c-0.4-0.449-0.85-0.88-1.376-1.258 c-0.46-0.331-0.805-0.654-1.027-0.899C28.295,7.161,28.426,6.991,29.536,7.516z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5G_vq2TUn1kG0Uv_gr33",
    x1: 20.805,
    x2: 21.07,
    y1: 21.757,
    y2: 1.718,
    gradientTransform: "matrix(.4545 0 0 1 22.338 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bebebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5G_vq2TUn1kG0Uv_gr33)",
    d: "M29.662,7.636c0.948,0.475,1.763,1.093,2.447,1.816s1.238,1.55,1.657,2.446 c0.783,1.674,1.126,3.532,1.126,5.269l0.039,8.642l-0.684-0.126l-0.525-0.993l-0.001-7.267c-0.002-0.098-0.002-0.353-0.006-0.453 c-0.036-1.552-0.28-3.147-0.899-4.636c-0.357-0.85-0.837-1.663-1.47-2.409c-0.379-0.446-0.807-0.876-1.308-1.26 c-0.417-0.319-0.756-0.629-1.009-0.877C28.519,7.29,28.586,7.099,29.662,7.636z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5H_vq2TUn1kG0Uv_gr34",
    x1: 26.635,
    x2: 26.897,
    y1: 21.75,
    y2: 1.849,
    gradientTransform: "matrix(.6364 0 0 1 14.892 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5H_vq2TUn1kG0Uv_gr34)",
    d: "M29.787,7.755c0.921,0.487,1.704,1.111,2.356,1.832c0.652,0.721,1.176,1.538,1.572,2.413 c0.757,1.671,1.076,3.514,1.075,5.206l0.044,8.541l-0.658-0.154l-0.353-1.143l-0.015-7.065c-0.002-0.11-0.004-0.326-0.008-0.438 c-0.04-1.494-0.264-3.05-0.853-4.52c-0.335-0.829-0.787-1.629-1.387-2.372c-0.359-0.443-0.764-0.872-1.24-1.262 c-0.374-0.306-0.707-0.603-0.991-0.855C28.743,7.421,28.746,7.207,29.787,7.755z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5I_vq2TUn1kG0Uv_gr35",
    x1: 29.869,
    x2: 30.129,
    y1: 21.736,
    y2: 2.001,
    gradientTransform: "matrix(.8182 0 0 1 7.446 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfdfdf"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5I_vq2TUn1kG0Uv_gr35)",
    d: "M29.912,7.875c0.894,0.499,1.644,1.129,2.265,1.848c0.621,0.719,1.112,1.526,1.487,2.38 c0.728,1.67,1.025,3.496,1.024,5.142l0.049,8.439l-0.631-0.181l-0.182-1.292l-0.03-6.863c-0.002-0.123-0.005-0.298-0.009-0.423 c-0.045-1.436-0.248-2.953-0.807-4.404c-0.313-0.809-0.736-1.596-1.304-2.336c-0.338-0.44-0.723-0.866-1.173-1.263 c-0.332-0.293-0.658-0.577-0.974-0.833C28.967,7.553,28.907,7.314,29.912,7.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    d: "M33.98,17.31c-0.028-1.492-0.19-3.121-0.772-4.696c-0.291-0.788-0.686-1.562-1.221-2.299 c-0.535-0.737-1.21-1.437-2.061-2.076c-0.736-0.553-0.86-0.816,0.11-0.244c0.867,0.511,1.585,1.147,2.174,1.864 c0.589,0.717,1.049,1.514,1.401,2.347c0.704,1.667,0.974,3.478,0.972,5.079l0.054,8.337l-0.605-0.209L33.98,17.31z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1a0a0",
    d: "M24,7.843c4.167,0,7.61,3.152,8.115,7.208c0-0.026,0.004-0.051,0.004-0.077 c0-4.507-3.653-8.007-8.16-8.007s-8.16,3.499-8.16,8.007c0,0.237,0.016,0.47,0.035,0.703C16.045,11.323,19.621,7.843,24,7.843z"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "VdtVIbCO4VspYflBVH0u5J_vq2TUn1kG0Uv_gr36",
    x1: 7,
    x2: 39.181,
    y1: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca65c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#f8e1ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#a77831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99621a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 24,
    x: 7,
    y: 20,
    fill: "url(#VdtVIbCO4VspYflBVH0u5J_vq2TUn1kG0Uv_gr36)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcefd2",
    d: "M41,20H7v0.156c4.346,1.099,10.357,1.78,17,1.78s12.654-0.681,17-1.78V20z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8e1ab",
    d: "M41,20H7v0.11c4.346,0.773,10.357,1.252,17,1.252s12.654-0.479,17-1.252V20z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9b661e",
    d: "M7,44h34v-0.088c-4.346-0.616-10.357-0.998-17-0.998s-12.654,0.381-17,0.998V44z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "VdtVIbCO4VspYflBVH0u5K_vq2TUn1kG0Uv_gr37",
    cx: -8.148,
    cy: 8.488,
    r: 2.905,
    gradientTransform: "matrix(-.7769 -.1817 .0495 -.2115 3.83 21.279)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#VdtVIbCO4VspYflBVH0u5K_vq2TUn1kG0Uv_gr37)",
    d: "M8.004,20.368c0.095-0.405,1.294-0.472,2.679-0.148s2.43,0.915,2.335,1.32 c-0.095,0.405-1.294,0.472-2.679,0.148S7.909,20.774,8.004,20.368z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePayment);
export default __webpack_public_path__ + "static/media/securePayment.0c46f408d35fe6eec67f8f588448b303.svg";
export { ForwardRef as ReactComponent };